import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { throwError } from 'rxjs';
import * as i1 from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import GeoJSON from 'ol/format/GeoJSON';
import * as i2 from '@anb/ng-configuratie';
import { fromExtent } from 'ol/geom/Polygon';
import { intersects, contains } from 'ol/format/filter';
import WFS from 'ol/format/WFS';
import Point from 'ol/geom/Point';

class BaseService {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleError(err) {
        return throwError(err);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: BaseService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: BaseService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: BaseService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

var SrsInformation;
(function (SrsInformation) {
    SrsInformation["_31370"] = "31370";
    SrsInformation["_4326"] = "4326";
    SrsInformation["_3857"] = "3857";
})(SrsInformation || (SrsInformation = {}));

var ParcelDataSource;
(function (ParcelDataSource) {
    ParcelDataSource["cadgis"] = "cadgis";
    ParcelDataSource["rvv"] = "rvv";
    ParcelDataSource["adp"] = "adp";
})(ParcelDataSource || (ParcelDataSource = {}));

class KadasterServiceInformatieVlaanderenV1 extends BaseService {
    constructor(httpClient, configuratieService) {
        super();
        this.httpClient = httpClient;
        this.configuratieService = configuratieService;
        this.api = 'CAPAKEY_SERVICE';
        this.api = configuratieService.getValue('/appl/configuratieservice/geo-url/capakey/v1');
    }
    getMunicipalities() {
        return this.httpClient
            .get(`${this.api}/municipality`, { responseType: 'json' })
            .pipe(catchError(this.handleError));
    }
    getDepartments(municipality) {
        return this.httpClient
            .get(`${this.api}/municipality/${municipality}/department`, { responseType: 'json' })
            .pipe(catchError(this.handleError));
    }
    getSections(municipality, department) {
        return this.httpClient
            .get(`${this.api}/municipality/${municipality}/department/${department}/section`, { responseType: 'json' })
            .pipe(catchError(this.handleError));
    }
    getParcels(municipality, department, section) {
        return this.httpClient
            .get(`${this.api}/municipality/${municipality}/department/${department}/section/${section}/parcel`, {
            responseType: 'json',
        })
            .pipe(catchError(this.handleError));
    }
    getParcel(x, y, geometry, 
    // eslint-disable-next-line no-underscore-dangle
    srs = SrsInformation._31370, parcelDataSource = ParcelDataSource.adp, status = 'actual') {
        let params = new HttpParams();
        params = params.append('x', x.toString());
        params = params.append('y', y.toString());
        if (geometry) {
            params = params.append('geometry', geometry);
        }
        if (srs) {
            params = params.append('srs', srs);
        }
        if (parcelDataSource) {
            params = params.append('data', parcelDataSource);
        }
        if (status) {
            params = params.append('status', status);
        }
        return this.httpClient
            .get(`${this.api}/parcel?${params.toString()}`, { responseType: 'json' })
            .pipe(catchError(this.handleError));
    }
    getParcelByCapaKey(capakey, geometry, 
    // eslint-disable-next-line no-underscore-dangle
    srs = SrsInformation._31370, parcelDataSource = ParcelDataSource.adp, status = 'actual') {
        let params = new HttpParams();
        if (geometry) {
            params = params.append('geometry', geometry);
        }
        if (srs) {
            params = params.append('srs', srs);
        }
        if (parcelDataSource) {
            params = params.append('data', parcelDataSource);
        }
        if (status) {
            params = params.append('status', status);
        }
        return this.httpClient
            .get(`${this.api}/parcel/${capakey}?${params.toString()}`, { responseType: 'json' })
            .pipe(catchError(this.handleError));
    }
    parseParcelObject(parcelObject) {
        const reader = new GeoJSON();
        if (!parcelObject.geometry || !parcelObject.geometry.shape) {
            return null;
        }
        const features = reader.readFeatures(parcelObject.geometry.shape, { dataProjection: 'EPSG:31370', featureProjection: 'EPSG:31370' });
        return features;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: KadasterServiceInformatieVlaanderenV1, deps: [{ token: i1.HttpClient }, { token: i2.AnbNgConfiguratieService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: KadasterServiceInformatieVlaanderenV1, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: KadasterServiceInformatieVlaanderenV1, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.AnbNgConfiguratieService }]; } });
class KadasterServiceInformatieVlaanderenV2 extends KadasterServiceInformatieVlaanderenV1 {
    constructor() {
        super(...arguments);
        this.api = this.configuratieService.getValue('/appl/configuratieservice/geo-url/capakey/v2');
    }
}

class KadasterModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: KadasterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.7", ngImport: i0, type: KadasterModule, imports: [CommonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: KadasterModule, providers: [KadasterServiceInformatieVlaanderenV1, KadasterServiceInformatieVlaanderenV2], imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: KadasterModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [],
                    exports: [],
                    providers: [KadasterServiceInformatieVlaanderenV1, KadasterServiceInformatieVlaanderenV2],
                }]
        }] });

var GeometryInformation;
(function (GeometryInformation) {
    GeometryInformation["bbox"] = "bbox";
    GeometryInformation["no"] = "no";
    GeometryInformation["full"] = "full";
})(GeometryInformation || (GeometryInformation = {}));

class GrbWfsService extends BaseService {
    constructor(httpClient, configuratieService) {
        super();
        this.httpClient = httpClient;
        this.configuratieService = configuratieService;
        this.api = 'WFS_SERVICE';
        this.api = configuratieService.getValue('/appl/configuratieservice/geo-url/GRB/wfs');
    }
    getParcelsFromBoxSelection(extent) {
        const geometry = fromExtent(extent);
        const request = new WFS().writeGetFeature({
            featureNS: 'GRB',
            featurePrefix: 'GRB',
            featureTypes: ['GRB:ADP'],
            srsName: 'EPSG:31370',
            outputFormat: 'application/json',
            filter: intersects('SHAPE', geometry),
        });
        const ogcFilter = new XMLSerializer().serializeToString(request);
        return this.httpClient.post(this.api, ogcFilter).pipe(catchError(this.handleError));
    }
    getParcelFromPoint(point) {
        const olPoint = new Point(point);
        const request = new WFS().writeGetFeature({
            featureNS: 'GRB',
            featurePrefix: 'GRB',
            featureTypes: ['GRB:ADP'],
            srsName: 'EPSG:31370',
            outputFormat: 'application/json',
            filter: contains('SHAPE', olPoint),
        });
        const ogcFilter = new XMLSerializer().serializeToString(request);
        return this.httpClient.post(this.api, ogcFilter).pipe(catchError(this.handleError));
    }
    getParcelsFromPolygon(polygon) {
        if (polygon.geometry.type !== 'Polygon') {
            throw new Error('GeoJSON is niet van type polygoon');
        }
        const olFeature = new GeoJSON().readFeature(polygon);
        const geometry = olFeature.getGeometry();
        const request = new WFS().writeGetFeature({
            featureNS: 'GRB',
            featurePrefix: 'GRB',
            featureTypes: ['GRB:ADP'],
            srsName: 'EPSG:31370',
            outputFormat: 'application/json',
            filter: intersects('SHAPE', geometry),
        });
        const ogcFilter = new XMLSerializer().serializeToString(request);
        return this.httpClient.post(this.api, ogcFilter).pipe(catchError(this.handleError));
    }
    getParcelsByCapaKeys(capakeys) {
        const params = new HttpParams()
            .set('CQL_FILTER', `CAPAKEY IN('${capakeys.join('\',\'')}')`)
            .set('service', 'WFS')
            .set('version', '2.0.0')
            .set('request', 'GetFeature')
            .set('outputFormat', 'application/json')
            .set('typeNames', 'GRB:ADP');
        return this.httpClient.get(this.api, { params }).pipe(catchError(this.handleError));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: GrbWfsService, deps: [{ token: i1.HttpClient }, { token: i2.AnbNgConfiguratieService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: GrbWfsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: GrbWfsService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.AnbNgConfiguratieService }]; } });

const AnbKadasterParameterKeys = [
    '/appl/configuratieservice/geo-url/GRB/wfs',
    '/appl/configuratieservice/geo-url/capakey/v1',
    '/appl/configuratieservice/geo-url/capakey/v2',
];

/*
 * Public API Surface of anb-ng-kadaster
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AnbKadasterParameterKeys, GeometryInformation, GrbWfsService, KadasterModule, KadasterServiceInformatieVlaanderenV1, KadasterServiceInformatieVlaanderenV2, ParcelDataSource, SrsInformation };
